"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _VoucherText = _interopRequireDefault(require("./VoucherText"));

var _reactToastify = require("react-toastify");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 auto;\n\n  @media (min-width: ", ") {\n    margin: 0;\n  }\n"])), function (props) {
  return props.theme.screenWidthXxs;
});

var StyledContent = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & .description {\n    display: none;\n  }\n\n  @media (min-width: ", ") {\n    margin-right: 1.5rem;\n\n    & .description {\n      display: block;\n    }\n  }\n"])), function (props) {
  return props.theme.screenWidthSm;
});

var StyledShareButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.5rem;\n  width: 2.5rem;\n"])));

var StyledCopyToast = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .icon {\n    font-size: 2rem;\n  }\n  .text {\n    margin: auto 1rem;\n  }\n"])));

var StyledCopyButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  & .material-icons {\n    font-size: 20px;\n  }\n"])));

var StyledCopyButtonText = _styledComponents.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-left: 0.25rem;\n  font-size: 0.75rem;\n"])));

var Wrapper = function Wrapper(_ref) {
  var voucherCode = _ref.voucherCode;
  var currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL;
  var voucherAmount = process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT;
  var voucherTitle = process.env.REACT_APP_VOUCHER_SHARE_TITLE || "Play this game to earn ".concat(currencySymbol).concat(voucherAmount);

  var copyToClipboard = function copyToClipboard() {
    _reactToastify.toast.success( /*#__PURE__*/_react.default.createElement(StyledCopyToast, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, {
      className: "icon"
    }, "content_copy"), /*#__PURE__*/_react.default.createElement("div", {
      className: "text"
    }, "Copied to clipboard")));
  };

  var onCopyClicked = function onCopyClicked(e) {
    e.preventDefault();
    copyToClipboard();
    navigator.clipboard.writeText(voucherCode);
  };

  var onShareClicked = function onShareClicked(e) {
    e.preventDefault();

    if (navigator.share) {
      navigator.share({
        title: process.env.REACT_APP_VOUCHER_SHARE_TITLE,
        text: "Hi, earn yourself a ".concat(process.env.REACT_APP_CURRENCY_SYMBOL).concat(process.env.REACT_APP_VOUCHER_PRIZE_AMOUNT, " Uber Eats discount code by placing your free picks!"),
        url: process.env.REACT_APP_VOUCHER_SHARE_URL || document.location.href
      }).then(function () {
        console.log("Successfully shared");
      }).catch(function (error) {
        console.error("Something went wrong sharing the blog", error);
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(StyledShareButton, {
    onClick: onShareClicked
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, "ios_share")), /*#__PURE__*/_react.default.createElement(StyledContent, null, /*#__PURE__*/_react.default.createElement(_VoucherText.default, {
    className: "description",
    isLabel: true,
    size: "md",
    textAlign: "center",
    marginBottom: "10px"
  }, "Use voucher code"), /*#__PURE__*/_react.default.createElement(_VoucherText.default, {
    size: "lg",
    isBold: true,
    textAlign: "center",
    marginBottom: "10px"
  }, voucherCode), /*#__PURE__*/_react.default.createElement(StyledCopyButton, {
    onClick: onCopyClicked
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, "content_copy"), /*#__PURE__*/_react.default.createElement(StyledCopyButtonText, null, "Copy It!"))));
};

var _default = Wrapper;
exports.default = _default;